import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useGuidedTour } from './useGuidedTour';
import { TourCard } from './TourCard';

/**
 * GuidedTour — tour d'horizon nouvel utilisateur, actif uniquement sur les
 * tenants démo (is_demo). Auto-lancé une fois par session. Aucun impact sur les
 * tenants en production.
 */
export default function GuidedTour() {
  const tour = useGuidedTour();
  if (!tour.isDemo) return null;
  const { active, step, index, total, isLast, rect, placement } = tour;

  return createPortal(
    <>
      <AnimatePresence>
        {active && step && (
          <motion.div
            key="tour-overlay"
            className="fixed inset-0 z-[9999]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Capte les clics : avance au clic en dehors de la carte */}
            <div className="absolute inset-0 cursor-default" onClick={tour.next} />

            {rect ? (
              <motion.div
                className="pointer-events-none absolute rounded-xl"
                initial={false}
                animate={{
                  top: rect.top - 8,
                  left: rect.left - 8,
                  width: rect.width + 16,
                  height: rect.height + 16,
                }}
                transition={{ type: 'spring', stiffness: 260, damping: 30 }}
                style={{
                  boxShadow: '0 0 0 9999px rgba(15, 23, 42, 0.72)',
                  border: '2px solid rgba(255,255,255,0.92)',
                }}
              />
            ) : (
              <div className="pointer-events-none absolute inset-0 bg-slate-900/70 backdrop-blur-[1px]" />
            )}

            <AnimatePresence mode="wait">
              <TourCard
                step={step}
                index={index}
                total={total}
                isLast={isLast}
                placement={placement}
                onPrev={tour.prev}
                onNext={tour.next}
                onClose={tour.close}
              />
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
    </>,
    document.body,
  );
}
